import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import * as auth from "./ducks/auth.duck";
import { metronic } from "../../_metronic";
import frete from './ducks/frete';

export const rootReducer = combineReducers({
	auth: auth.reducer,
	builder: metronic.builder.reducer,
	frete,
});

export function* rootSaga() {
	yield all([auth.saga()]);
}
